<template lang="pug">
  .menu-gallery
    //bg-pattern
    .upper
      .copy 长按保存图片
    .bottom
      scroll-bar(v-if="gallery.length>1" :progress="progress" :ratio="scrollRatio")
      .swiper-container(id="photo-vertical")
        .swiper-wrapper
          .swiper-slide(v-for="(img,index) in gallery" :key="index")
            .photo(:class="index%2===0? 'left': 'right'")
              img(:src="img[0]")
              img.shadow-img(:src="img[1]")
              svg.shadow(viewBox="0 0 228 327" fill="none" xmlns="http://www.w3.org/2000/svg")
                use(xlink:href="#photo-shadow")
          //.swiper-slide.blank



</template>
<script>
import {mapState, mapMutations} from 'vuex'
import {TweenMax, TimelineMax, Power2, Circ} from 'gsap'
import IconClose from 'src/components/vca/widgets/IconClose'
import ScrollBar from 'src/components/vca/widgets/ScrollBar'
import { Swiper } from 'swiper/dist/js/swiper.esm.js'
import Raf from 'src/helpers/Raf'
//import Component from '@/components/Component'

export default {
  name: "MenuGallery",
  props: {
    active: {
      default: false,
      required: true
    }
  },
  components: {
    IconClose,
    ScrollBar
  },
  data() {
    return {
      scrollRatio: 1,
      progress: 0,
      scrollTop: 0,
      scrollHeight: 0
    }
  },
  computed:{
    ...mapState('app', ['gallery'])
  },
  methods: {
    init() {},
    update(){
      this.progress = (this.scrollTop - this.swiper.$wrapperEl[0].getBoundingClientRect().top)/this.scrollHeight
    }
  },
  mounted() {
    this.init()
    this.swiper = new Swiper('#photo-vertical', {
      direction: 'vertical',
      slidesPerView: 2,
      slidesOffsetBefore: 30,
      slidesOffsetAfter: 80,
      spaceBetween: 50,
      freeMode: true,

    })
    this.scrollRatio = this.swiper.height/this.swiper.$wrapperEl[0].scrollHeight
    this.scrollTop = this.swiper.$wrapperEl[0].getBoundingClientRect().top
    this.scrollHeight = this.swiper.$wrapperEl[0].scrollHeight-this.swiper.height


  },
  beforeDestroy(){
    Raf.remove(this.update)
  },
  watch: {
    active(val){
      if (val) {
        Raf.add(this.update)
      } else{
        Raf.remove(this.update)
      }
    }
  }
}
</script>


<style lang="sass">
  @import "src/styles/common.sass"
  .menu-gallery
    transform: translateX(100%)
    pointer-events: all
    top: 0
    left: 0
    //opacity: 0
    position: absolute
    width: 100%
    height: 100%
    //background: #ffd81b

    //background: #ffd81b

     padding-left: 4rem

    //background: $cl-blue

    //background: linear-gradient(171.36deg, #FD9F02 69.87%, #E68203 112.08%)
    overflow: hidden

    //.bg-pattern
      mix-blend-mode: color-burn
    .upper
      margin: auto
      width: 80%
      height: 17%
      //background: rgba(225, 81, 37, 0.51)
      position: relative
      .copy
        position: absolute
        width: 80%
        left:  10%
        bottom: 0.1rem
        line-height: 0.4rem
        font-size: $fs-m
        background: rgba(255, 255, 255, 0.1)
        color: #FFF9EE
        text-align: center
        height: 0.4rem
        border-radius: 0.2rem
    .bottom
      position: relative
      width: 80%
      height: 83%
      margin: auto
      //background: rgba(58, 96, 46, 0.47)
      z-index: 999
      #photo-vertical
        height: 100%
        width: 100%
        //overflow: scroll

        //.photos
          width: 100%
          display: flex
          align-items: center
          flex-direction: column
          justify-content: space-between
        .blank
          height: 1rem
        .photo
          line-height: 0
          width: 2rem
          height: auto !important

          margin: auto
          //background: red
          position: relative
          img

            width: 100%
            object-fit: cover
            display: block
            position: relative
            z-index: 100
            border: 0.15rem #FFF9EE solid
            border-bottom: 0.55rem #FFF9EE solid
            border-radius: 0.05rem
            &.shadow-img
              pointer-events: all
              opacity: 0
              position: absolute
              top: 0
              left: 0
              z-index: 101

          svg
            display: block
            width: 100%
            position: absolute
            top: 0
            left: 0
            z-index: 99


          &.right
            img
              transform: rotateZ(5deg)
            svg
              transform: rotateZ(2deg) scale(1.16) translate3d(1.5%, 14%, 0)
          &.left
            img
              transform: rotateZ(-5deg)
            svg
              transform: rotateZ(-7deg) scale(1.16) translate3d(0, 14%, 0)







</style>